module.exports = __webpack_public_path__ + "static/media/icone_oeuvreprotestante.77139d9f.svg";